import { useAppSelector } from '@/hooks/store';
import { usePosthogTracking } from '@/hooks/usePosthogTracking';
import { selectCurrentUser } from '@/store/features/users';
import { buildPostHogGlobalProperties, PostHogEvent } from '@/utils/posthog';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePosthogStatus } from './PosthogTrackingProvider';

export const PostHogPageViewTracker = () => {
  const location = useLocation();
  const { allowTracking, trackPostHogEvent } = usePosthogTracking();
  const { isPosthogReady, isPosthogIdentified } = usePosthogStatus();
  const currentUser = useAppSelector(selectCurrentUser);

  useEffect(() => {
    if (
      !allowTracking ||
      !currentUser ||
      !isPosthogReady ||
      !isPosthogIdentified
    ) {
      return;
    }

    // We don't want to track the initial page that loads before the user is authenticated
    if (allowTracking && location.pathname !== '/') {
      trackPostHogEvent(PostHogEvent.PAGE_VIEW, {
        normalized_path: location.pathname,
        ...buildPostHogGlobalProperties(currentUser.account, currentUser),
      });
    }
  }, [location.pathname, isPosthogReady, isPosthogIdentified, allowTracking]);

  return null;
};
